// French translations - using English as fallback for now
export default {
  // Common
  app: {
    name: 'Coloursense',
    tagline: 'Découvrez Vos Couleurs Parfaites',
  },
  common: {
    back: 'Retour',
    cancel: 'Annuler',
    save: 'Enregistrer',
    share: 'Partager',
    create: 'Créer',
    delete: 'Supprimer',
    edit: 'Modifier',
    loading: 'Chargement...',
    error: 'Une erreur est survenue',
    success: 'Succès !',
    tryAgain: 'Réessayer',
    reset: 'Réinitialiser',
  },

  // Premium Features
  premium: {
    title: 'Débloquer les Fonctionnalités Premium',
    subtitle:
      'Passez à Coloursense Premium pour un accès complet à toutes les fonctionnalités',
    smartWardrobe: 'Garde-robe Intelligente',
    wardrobeDesc:
      'Étiquetez vos vêtements et découvrez ce qui correspond à votre palette de couleurs',
    wearToday: "Que Porter Aujourd'hui",
    wearTodayDesc:
      'Obtenez des suggestions de tenues basées sur la météo et vos couleurs',
    unlimited: 'Analyses Illimitées',
    unlimitedDesc:
      "Créez des profils de couleur illimités et enregistrez votre historique d'analyses",
    noAds: 'Sans Publicités',
    noAdsDesc:
      "Profitez d'une expérience sans publicités dans toute l'application",
    monthly: 'Mensuel',
    yearly: 'Annuel',
    save: 'Économisez 30%',
    perMonth: 'par mois',
    perYear: 'par an',
    upgradeButton: 'Passer à Premium',
    processing: 'Traitement en cours...',
    restore: 'Restaurer les Achats',
  },

  // Subscription Context
  subscription: {
    freePlan: 'Plan Gratuit',
    premiumPlan: 'Plan Premium',
    upgradeSuccess: 'Mise à niveau vers Premium réussie !',
    upgradeError: 'Échec de la mise à niveau vers Premium',
    restoreSuccess: 'Achats restaurés avec succès !',
    restoreError: 'Échec de la restauration des achats',
    premiumRequired: 'Premium Requis',
    premiumFeature: 'Ceci est une fonctionnalité premium',
    upgradeToAccess: 'Passez à Premium pour accéder à cette fonctionnalité',
    goToPremium: 'Aller à Premium',
    continueFree: 'Continuer avec Gratuit',
  },
};
